import { ChangeEvent } from 'react';
import styles from './radio.module.css';

const { radio, input, label } = styles;

interface RadioProps {
  checked?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  value?: string;
  name?: string;
  ref?: React.Ref<HTMLInputElement>;
}

export default function Radio({ checked, onChange, disabled, value, name, ref }: RadioProps) {
  return (
    <label
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={label}
    >
      <input
        type="radio"
        ref={ref}
        checked={checked}
        disabled={disabled}
        value={value}
        name={name}
        className={input}
        onChange={onChange}
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
      <span className={radio}></span>
    </label>
  );
}
